import { GRID_HELPER_ID } from '@/domain/selection/reservedSelectionIds';
import { ESelectionKind } from '@/domain/selection/ESelectionKind';

// Pure map from a selected id (Pinia's selectedFieldId) to its
// domain-level kind. Kept in the domain so any layer needing the
// kind (store, controllers, presentation) can derive it without
// asking the engine — the engine only reports the id.

function deriveSelectionKind(id: string | undefined): ESelectionKind {
    if (id === undefined) {
        return ESelectionKind.None;
    }
    if (id === GRID_HELPER_ID) {
        return ESelectionKind.Grid;
    }
    return ESelectionKind.Field;
}

export { deriveSelectionKind };
